import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
countries.registerLocale(enLocale);
function toFlagEmoji(iso2) {
    return iso2
        .toUpperCase()
        .split('')
        .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
        .join('');
}
function buildCountryOptions() {
    return getCountries()
        .map((iso2) => ({
        iso2,
        name: countries.getName(iso2, 'en') || iso2,
        callingCode: `+${getCountryCallingCode(iso2)}`,
        flag: toFlagEmoji(iso2),
    }))
        .sort((left, right) => {
        if (left.name === right.name) {
            return left.callingCode.localeCompare(right.callingCode);
        }
        return left.name.localeCompare(right.name);
    });
}
export const COUNTRY_OPTIONS = buildCountryOptions();
export function findCountryOptionByCallingCode(callingCode) {
    return COUNTRY_OPTIONS.find((option) => option.callingCode === callingCode.trim()) || null;
}
